import React, { useEffect, useState } from "react";

export default function PatientManager() {
  const [search, setSearch] = useState("");
  const [patients, setPatients] = useState([]);
  const [page, setPage] = useState(1);
  const pageSize = 50;
  const totalPages = Math.ceil(patients.length / pageSize);
  const [form, setForm] = useState({ name: "", email: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/users/patients`)
      .then(res => res.json())
      .then(data => setPatients(data))
      .catch(() => setPatients([]));
  }, []);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleAdd = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/users/createUser`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, role: "patient" })
      });
      const result = await res.json();
      if (!res.ok) throw new Error(result.msg || "Failed to add patient");
      setPatients([...patients, result]);
      setForm({ name: "", email: "" });
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  const handleDelete = async _id => {
    if (!window.confirm("Delete this patient?")) return;
    await fetch(`${process.env.REACT_APP_API_BASE_URL}/users/inactivate/${_id}`, { method: "PUT" });
    setPatients(patients.filter(p => p._id !== _id));
  };

  // Edit/update logic can be added similarly

  return (
    <div>
      <h5>Add Patient</h5>
      <form className="row g-2 mb-3" onSubmit={handleAdd}>
        <div className="col-md-5">
          <input name="name" value={form.name} onChange={handleChange} className="form-control" placeholder="Name" required />
        </div>
        <div className="col-md-5">
          <input name="email" value={form.email} onChange={handleChange} className="form-control" placeholder="Email" required />
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary w-100" type="submit" disabled={loading}>Add</button>
        </div>
        {error && <div className="col-12 text-danger">{error}</div>}
      </form>
      <h5>Patients List</h5>
      <div className="mb-2">
        <input type="text" className="form-control" placeholder="Search patients..." value={search || ''} onChange={e => setSearch(e.target.value)} />
      </div>
      <div className="table-responsive w-100">
        <table className="table table-bordered w-100">
          <thead><tr><th>Name</th><th>Email</th><th>Actions</th></tr></thead>
          <tbody>
            {patients.filter(pat => {
              if (!search) return true;
              const val = search.toLowerCase();
              return (pat.name?.toLowerCase().includes(val) || pat.email?.toLowerCase().includes(val));
            }).slice((page-1)*pageSize, page*pageSize).map(pat => (
              <tr key={pat._id}>
                <td>{pat.name}</td>
                <td>{pat.email}</td>
                <td>
                  <span style={{cursor:'pointer',marginRight:'12px'}} title="Edit">
                    <i className="mdi mdi-pencil" onClick={() => alert('Edit patient feature coming soon!')}></i>
                  </span>
                  <span style={{cursor:'pointer'}} title="Delete">
                    <i className="mdi mdi-delete" onClick={() => handleDelete(pat._id)}></i>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-end align-items-center mt-2 gap-2">
            <button className="btn btn-outline-secondary btn-sm" disabled={page===1} onClick={()=>setPage(page-1)}>Prev</button>
            <span>Page {page} of {totalPages}</span>
            <button className="btn btn-outline-secondary btn-sm" disabled={page===totalPages} onClick={()=>setPage(page+1)}>Next</button>
          </div>
        )}
      </div>
    </div>
  );
}
